import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/11/principle/theta--30.m4v`,
          controls: true,
          autoplay: true,
          loop: true,
        },
      },
      styles: {
        padding: "0 14.7%",
      },
    },
  },
];

export default components;
